import { alpha, Chip } from '@mui/material';

export type StatusChipProps = {
  status: 'active' | 'pending' | 'suspend' | 'inactive' | 'rejected' | 'suspended';
};

const statusMap = {
  active: {
    label: 'Active',
    color: '#67CA24',
  },
  pending: {
    label: 'Pending',
    color: '#F0AD00',
  },
  suspend: {
    label: 'Suspend',
    color: '#FF4D49',
  },
  suspended: {
    label: 'Suspended',
    color: '#FF4D49',
  },
  rejected: {
    label: 'Rejected',
    color: '#FF4D49',
  },
  inactive: {
    label: 'Inactive',
    color: '#FF4D49',
  },
};

export const StatusChip: React.FC<StatusChipProps> = (props) => {
  const { status } = props;

  // ======================= VIEWS
  return (
    <Chip
      variant="filled"
      size="small"
      label={statusMap[status].label}
      sx={{
        fontWeight: 600,
        color: statusMap[status].color,
        backgroundColor: alpha(statusMap[status].color, 0.12),
      }}
    />
  );
};

// ======================= EXPORT
export default StatusChip;
